/** Assets em `client/public/brand/` (servidos em `/brand/...`). */
export const BRAND_FAVICON = '/brand/favicon.png';

export const BRAND_LOGO = {
  /** Fundo escuro (fotos, faixas pretas). */
  onDark: '/brand/logo-hack-academy-branco.png',
  /** Fundo claro (o app). */
  onLight: '/brand/logo-hack-academy-preto.png',
} as const;
